
import React from 'react';
import { motion } from 'framer-motion';
import { Skeleton } from '@/components/ui/skeleton';

interface ThreadItemSkeletonProps {
  index?: number;
}

const ThreadItemSkeleton: React.FC<ThreadItemSkeletonProps> = ({ index = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.1, duration: 0.3 }}
      className="group relative flex items-start gap-3 p-3 rounded-md cursor-pointer transition-all duration-300 border border-transparent"
    >
      {/* Background gradient - matches ThreadItem */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-100/40 via-purple-100/30 to-blue-100/40 dark:from-purple-900/15 dark:via-blue-900/10 dark:to-purple-900/15 opacity-70 rounded-md" />
      
      {/* Glass effect with gradient background - matches ThreadItem */}
      <div className="absolute inset-0 backdrop-blur-md border border-white/20 dark:border-white/5 rounded-md bg-gradient-to-br from-white/70 to-white/30 dark:from-slate-800/70 dark:to-slate-900/30" />
      
      {/* Subtle gradient animation - matches ThreadItem */}
      <div className="absolute inset-0 bg-gradient-to-r from-blue-100/10 via-purple-100/10 to-blue-100/10 dark:from-blue-900/10 dark:via-purple-900/10 dark:to-blue-900/10 rounded-md overflow-hidden" />
      
      {/* Content - matches ThreadItem structure exactly */}
      <div className="relative z-10 flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2 min-w-0 flex-1">
            {/* Message icon skeleton */}
            <Skeleton className="w-3.5 h-3.5 flex-shrink-0 mt-0.5 rounded" />
            
            <div className="flex-1 min-w-0">
              {/* Last user message skeleton */}
              <Skeleton className="h-[20px] w-3/4 mb-0" />
            </div>
          </div>
          
          {/* Delete button skeleton */}
          <Skeleton className="w-6 h-6 rounded flex-shrink-0" />
        </div>
        
        {/* Metadata: Date and Assistant Avatars - matches ThreadItem spacing */}
        <div className="flex items-center justify-between mt-2">
          <Skeleton className="h-3 w-12" />
          
          {/* Assistant Avatars skeleton */}
          <div className="flex -space-x-1">
            <Skeleton className="w-5 h-5 rounded-full border border-white/20" />
            <Skeleton className="w-5 h-5 rounded-full border border-white/20" />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ThreadItemSkeleton;
